import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

interface StyleToggler {
    id?: string;
    tag?: string;
    class?: string;
    styles: string[];
    setStyles?: {
        key: string;
        value: string;
    }[];
    elements?: any[];
    oldStyles?: any[];
}

export class PdfHelperFunctions {

    // if HTMLContent != null => only HTMLContent will be rendered
    static getPdf(HTMLelementId: string, HTMLContent?: string): Promise<jsPDF> {
        const pratica = document.getElementById(HTMLelementId);

        for (const select of Array.prototype.slice.call(pratica.getElementsByTagName('select'))) {
            let i = 0;
            while (select.classList.contains('form-control') && select.childNodes && i < select.childNodes.length) {
                if (select.childNodes[i].value !== select.value) {
                    select.childNodes[i].disabled = true;
                }
                i++;
            }
        }

        const data = this.hiddenClone(pratica, HTMLContent);
        this.renameID(data);
        const styleToggler: StyleToggler[] = [
            { tag: 'select', styles: ['boxShadow'] },
            { tag: 'textarea', styles: ['boxShadow'] },
            { tag: 'label', styles: ['transform'], setStyles: [{key: 'transform', value: 'translateY(-45%)'}] },
            { class: 'btn', styles: ['display'] },
            { class: 'for-label', styles: ['transform'], setStyles: [{key: 'transform', value: 'translateY(-100%)'}] },
            { class: 'mat-list-item-content', styles: ['transform'], setStyles: [{key: 'transform', value: 'translateY(-20%)'}] },
            { class: 'mat-expansion-panel', styles: ['boxShadow'] },
            { class: 'errors-container', styles: ['display'] },
            { class: 'table-container', styles: ['max-height'] }
        ];

        this.hideStyles(styleToggler, data);

        const screenX = window.pageXOffset;
        const screenY = window.pageYOffset;

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto'
        });

        return html2canvas(data).then(canvas => {

            for (const select of Array.prototype.slice.call(pratica.getElementsByTagName('select'))) {
                let i = 0;
                while (select.classList.contains('form-control') && select.childNodes && i < select.childNodes.length) {
                    if (select.childNodes[i].value !== select.value) {
                        select.childNodes[i].disabled = false;
                    }
                    i++;
                }
            }

            document.body.removeChild(data);
            const imgWidth = 210;
            const pageHeight = 295;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            let heightLeft = imgHeight;
            const margin = 20;

            const imgData = canvas.toDataURL('image/png', 1.0);

            const doc = new jsPDF({orientation: 'p', unit: 'mm', compress: true});
            let position = 0;

            doc.setLineWidth(margin);
            doc.setDrawColor('white');

            doc.addImage(imgData, 'PNG', margin, position + margin, imgWidth - 40, imgHeight + ((imgHeight < pageHeight) ? 0 : 15));
            doc.line(0 , margin / 2, 1000, margin / 2);
            doc.line(0 , pageHeight - (margin / 2) + 2, 1000, pageHeight - (margin / 2) + 2);

            heightLeft -= pageHeight;
            let numMargins = 3;

            while ((heightLeft + margin * (numMargins - 1)) > 0) {
                position = heightLeft - imgHeight;
                doc.addPage();
                doc.setLineWidth(margin);
                doc.addImage(imgData, 'PNG', margin, position + ((margin - 0.8) * numMargins), imgWidth - 40, imgHeight + 15);
                doc.line(0 , margin / 2, 1000, margin / 2);
                doc.line(0 , pageHeight - (margin / 2) + 2, 1000, pageHeight - (margin / 2) + 2);
                heightLeft -= pageHeight;
                numMargins += 2;
            }
            this.showStyles(styleToggler);
            window.scrollTo({ top: screenY, left: screenX, behavior: 'auto' });

            return Promise.resolve(doc);
        });
    }

    private static hideStyles( styleToggler: StyleToggler[], container: HTMLElement) {
        for (const st of styleToggler) {
            st.elements = Array.prototype.slice.call(
            st.tag ? container.getElementsByTagName(st.tag) :
            st.class ? container.getElementsByClassName(st.class) :
            st.id ? [document.getElementById(st.id)] : []);
            st.oldStyles = [];
            for (const [i, element] of st.elements.entries()) {
                st.oldStyles[i] = [];
                for (const [j, styleName] of st.styles.entries()) {
                    st.oldStyles[i][j] = element.style[styleName];
                    element.style[styleName] = 'none';
                }
                if (st.setStyles)
                    for (const newStyle of st.setStyles)
                        element.style[newStyle.key] = newStyle.value;
            }
        }
    }

    private static showStyles(styleToggler: StyleToggler[]) {
        for (const st of styleToggler)
            for (const [i, element] of st.elements.entries())
                for (const [j, styleName] of st.styles.entries())
                    element.style[styleName] = st.oldStyles[i][j];
    }

    private static hiddenClone(element, HTMLContent?) {
        const clone = element.cloneNode(true);
        if (HTMLContent)
            clone.innerHTML = '<div class="w-100">' + HTMLContent + '</div>';
        const style = clone.style;
        style.position = 'relative';
        style.top = window.innerHeight + 'px';
        style.left = 0;
        style.zoom = '1.7';
        document.body.appendChild(clone);
        return clone;
    }

    private static renameID(data: HTMLElement) {
        data.id = data.id + (Math.random() * 100);
        const children = data.childNodes;
        children.forEach(child => this.renameID(child as HTMLElement));
    }
}
